export const classNames = (...args) => args
    .map((arg) => {
    if (Array.isArray(arg)) {
        return arg.length ? classNames(...arg) : "";
    }
    else if (arg &&
        typeof arg === "object") {
        return classNames(Object.entries(arg)
            .filter(([_, value]) => value)
            .map(([key]) => key));
    }
    return typeof arg === "string" ? arg : "";
})
    .filter((str) => str !== "")
    .join(" ");
